import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'antd';
import { Header, Banner } from 'arcl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCog } from '@fortawesome/pro-light-svg-icons';
import { fetchDirectoryData } from 'Src/alumniDirectories/actions';
import LottieLoader from 'Src/common/components/lottieLoader';
import { LIST_OF_BANNER_IMAGES } from 'Src/alumniDirectories/constants';
import VerificationContext from 'Src/common/context/verification';
import FroalaEditorView from 'Src/common/components/froalaEditor/froalaEditorView';

import './style.scss';

/**
 * Directory Details Component
 */
function DirectoryDetails() {
  const [sdkConfig, setSDKConfig] = useState({});
  const [directory, setDirectory] = useState({});
  const [loading, setLoading] = useState(true);
  const { isVerified, id } = useContext(VerificationContext);

  const updateSDKConfig = () => {
    const config = {
      host: window.location.host,
      protocol: window.location.protocol,
      staticPath: window.staticPath,
      id: id,
      path: '/d/',
      containerId: 'iframe-preview-block',
    };

    // to check staticPath is path or proper url (to handle dev server case )
    if (!window.staticPath.startsWith(window.location.protocol)) {
      config.staticPath = `${config.protocol}//${config.host}${config.staticPath}`;
    }
    config.siteUrl = window.location.origin;
    config.url = `${config.protocol}//${config.host}${config.path}`;
    setSDKConfig(config);
  };

  useEffect(() => {
    setLoading(true);
    updateSDKConfig();
    // prevent adding more iframes
    if (isVerified) {
      fetchDirectoryData(id).then((response) => {
        setDirectory(response.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [isVerified, id]);

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Choose>
      <When condition={loading}>
        <LottieLoader />
      </When>
      <Otherwise>
        <div className="directory-details-wrapper">
          <Header
            leftSideItems={[
              <If condition={window.history.length > 1}>
                <div className="directory-details-back-btn" onClick={handleGoBack}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
              </If>,
              <a href="/" className="arc-focus-outline">
                <img src={window.customerLogo} alt={`${window.collegeName} logo`} className="header-logo-img" />
              </a>,
            ]}
            style={{ width: '100%' }}
            role="banner"
          />
          <div className="directory-details-body">
            <Banner
              bannerHeight='100%'
              innerContainerProps={{ id: 'directory-banner' }}
              color={window.primaryColor}
              title={directory?.name}
              bannerRandomImages={LIST_OF_BANNER_IMAGES}
              style={{ width: '100%' }}
            />
            <div role="main">
              <If condition={directory?.description}>
                <div className="directory-description-div">
                  <FroalaEditorView model={directory?.description} />
                </div>
              </If>
              <div className="directory-details-iframe-wrapper">
                <div id="iframe-preview-block" />
                <script id="directory-sdk-code">
                  {(function (i, u, h, s, c) {
                    if (!h || !i || !u || !s) {
                      return;
                    }
                    const doc = document;
                    const sb = doc.createElement('script');
                    sb.async = 1;
                    sb.src = `${h}js/almasdk/almasdk.js`;
                    // eslint-disable-next-line no-multi-assign
                    sb.onload = sb.onreadystatechange = () => {
                      window.almaSDK.init(i, u + i, h, s, c);
                    };
                    doc.body.appendChild(sb);
                  })(sdkConfig.id, sdkConfig.url, sdkConfig.staticPath, sdkConfig.siteUrl, 'directory')}
                </script>
              </div>
            </div>
          </div>
          <If condition={window.isSiteAdmin && window.isSiteAdmin !== 'false'}>
            <Button
              icon={<FontAwesomeIcon icon={faCog} className="mr8" />}
              shape="round"
              type="primary"
              className="admin-link-btn"
              href={`/admin/directories/${id}`}>
              Admin
            </Button>
          </If>
        </div>
      </Otherwise>
    </Choose>
  );
}

export default DirectoryDetails;
